import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "How fast do I actually get my video?", a: "Growth and Domination packs are delivered within 24 hours. The Single Reel pack ships within 48 hours. You'll get an email the moment it's ready." },
  { q: "What do you need from me to start?", a: "Just your product or service page URL and your brand guidelines (colors, tone, logo). You can upload logo and asset files right in the order form." },
  { q: "Are the videos Instagram-ready?", a: "Yes — every video is produced in native 9:16 vertical format, optimized for Instagram Reels and Stories, with trending audio and captions." },
  { q: "Do I own the video and can I run ads with it?", a: "100%. Full commercial usage rights are included in every pack. Post it organically or run it as a paid ad — it's yours." },
  { q: "How does payment work?", a: "You pay the full price securely via Razorpay when you place the order. You get an instant confirmation email, then your video lands within the promised window." },
  { q: "Can I get a refund, replacement or revision?", a: "No. All sales are final — we don't offer refunds, replacements or revisions. Please share all your brand details and assets when you order. See our Refund Policy for details." },
];

export const FAQ = () => (
  <section id="faq" className="py-16 lg:py-24">
    <div className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-12">
      <div className="text-center mb-10">
        <p className="text-xs font-mono uppercase tracking-widest text-[#00F5D4] mb-3">Questions</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">Everything you're wondering</h2>
      </div>
      <Accordion type="single" collapsible data-testid="faq-accordion" className="space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i + 1}`}
            className="rounded-2xl bg-[#12141C] border border-white/10 px-5">
            <AccordionTrigger className="text-left text-white hover:no-underline py-5">{f.q}</AccordionTrigger>
            <AccordionContent className="text-slate-400 leading-relaxed pb-5">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
